/**
 * WCST — types runtime.
 *
 * Paradigm Berg 1948 / Heaton WCST-128. Trial = single card sort.
 *
 * 4 reference piles, fixees :
 *   pile 0 : 1 cercle rouge
 *   pile 1 : 2 triangles verts
 *   pile 2 : 3 croix jaunes
 *   pile 3 : 4 etoiles bleues
 *
 * A chaque trial, une carte "test" est presentee (combinaison couleur/forme/nombre
 * tiree au sort). User clique la pile cible. La regle courante (color | shape | number)
 * est cachee ; user la decouvre par feedback. Apres N succes consecutifs (= valeur
 * staircase), la regle change silencieusement.
 */
export const REFERENCE_PILES = [
    { idx: 0, card: { color: 'red', shape: 'circle', number: 1 } },
    { idx: 1, card: { color: 'green', shape: 'triangle', number: 2 } },
    { idx: 2, card: { color: 'yellow', shape: 'cross', number: 3 } },
    { idx: 3, card: { color: 'blue', shape: 'star', number: 4 } },
];
//# sourceMappingURL=types.js.map